<section class="d-flex mt-2 justify-content-between">
    <section class="btn-toolbar">
        <app-statistik-tidsforbrug-options-periode class="d-flex"
                                                   (periodeChange)="onPeriodeChange($event)"
                                                   [periode]="periode"></app-statistik-tidsforbrug-options-periode>
        <app-statistik-options-afdelinger class="d-flex" (selectAfdeling)="onSelectAfdeling($event)"></app-statistik-options-afdelinger>
        <app-statistik-options-grupper class="d-flex" (selectGruppe)="onSelectGruppe($event)"></app-statistik-options-grupper>
    </section>
    <section class="btn-toolbar me-2">
        <div>
            <button (click)="onExport()" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>

<div class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th colspan="2"></th>
            <th [attr.colspan]="uproduktiveSager?.length + 1"  class="border text-center"> Realiseret tid </th>
            <th colspan="4"></th>
        </tr>

        <tr>
            <th colspan="2"></th>
            <th class="kunderelateret__header--background"></th>
            <th [attr.colspan]="uproduktiveSager?.length" class="background--dr-grey text-center"> Ikke kunderelateret tid </th>
            <th colspan="5"></th>
        </tr>

        <tr>
            <th> Init </th>
            <th> Plan tid kunder <br> (hele måneder) </th>
            <th class="kunderelateret__header--background"> Kunderelateret </th>
            <ng-container *ngFor="let uproduktiveSag of uproduktiveSager; trackBy: trackUproduktiveSagPID">
                <th class="background--dr-grey">{{uproduktiveSag.beskrivelse}}</th>
            </ng-container>
            <th> Brugt tid ialt </th>
            <th> Norm tid</th>
            <th> +- tid </th>
        </tr>
        </thead>

        <tbody>
        <ng-container *ngFor="let medarbejder of medarbejdere; trackBy: trackMedarbejderInit">
            <ng-container *ngIf="(isMedarbejderInSelectedGruppe(medarbejder) || !selectedGruppeId) && (isMedarbejderInSelectedAfdeling(medarbejder) || !selectedAfdelingId)">
                <tr class="item__tr">
                    <td> {{medarbejder.init}} </td>
                    <td class="text-end"
                        [ngClass]="{'link-td': medarbejder.plan_tid_kunder}"  (click)="openPlantidModal(medarbejder)"> {{medarbejder.plan_tid_kunder | time}} </td>
                    <td class="realiseret__content--background text-end">{{ medarbejder.kundeRelateret | time }}</td>
                    <ng-container *ngFor="let uproduktiveSag of uproduktiveSager; trackBy: trackUproduktiveSagPID">
                        <td class="realiseret__content--background text-end" [ngClass]="{'link-td': (medarbejder.ikkeKundeTid | totalIkkeKundeTid:uproduktiveSag.pid) !== 0}" (click)="openIKRTModal(medarbejder, uproduktiveSag)"> {{medarbejder.ikkeKundeTid | totalIkkeKundeTid:uproduktiveSag.pid | time}} </td>
                    </ng-container>
                    <td class="text-end"> {{medarbejder.total | time}} </td>
                    <td class="text-end"> {{medarbejder.normtid | time}} </td>
                    <td class="text-end"> {{medarbejder.total - medarbejder.normtid | time}} </td>
                </tr>
            </ng-container>
        </ng-container>
        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
            <tr>
                <th>Total</th>
                <th class="text-end">{{calcTotals('plan_tid_kunder') | time}}</th>
                <th class="text-end">{{calcTotals('kundeRelateret') | time}}</th>
                <th class="text-end" *ngFor="let uproduktiveSag of uproduktiveSager; trackBy: trackUproduktiveSagPID">{{calcUproduktiveSagTotals(uproduktiveSag) | time}}</th>
                <th class="text-end">{{calcTotals('brugt-tid-ialt') | time}}</th>
                <th class="text-end">{{calcTotals('norm-tid') | time}}</th>
                <th class="text-end">{{calcTotals('+-tid') | time}}</th>
            </tr>
        </tfoot>

    </table>
</div>
